<template>
  <div>
    <PageAllow
      controller="ProductionPlans"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-card v-if="isNew">
        <v-card-title class="px-6 py-4">
          {{ $t("CRUD.newInfo", [$t("ProductionPlans.ObjectName")]) }}
          <v-chip
            v-if="production_plan.cancel_flg"
            small
            label
            outlined
            class="ms-4 mt-1"
            color="danger"
          >
            {{ $t("CRUD.cancelled") }}
          </v-chip>
          <v-spacer />
          <v-sheet class="pt-1 transparent-background-color d-inline-block">
            <v-btn
              v-if="isNew && !next"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1 elevation-1"
              @click.stop="next = true"
            >
              {{ $t("ProductionPlans.actions.next") }}
            </v-btn>
            <v-btn
              v-if="(isNew && next) || preview"
              small
              dark
              outlined
              color="secondary"
              class="px-2 me-2 mb-1 elevation-1"
              @click.stop="preview ? (preview = false) : (next = false)"
            >
              <v-icon x-small class="pe-1">fa-times</v-icon>
              {{ $t("CRUD.backForModify") }}
            </v-btn>
            <v-btn
              v-if="(isNew && next) || mode == 'edit'"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1"
              @click.stop="preview ? doSubmit() : doPreview()"
            >
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{
                action
                  ? action == "confirm"
                    ? $t("ProductionPlans.actions.confirmSubmit")
                    : action == "approve"
                    ? $t("ProductionPlans.actions.approveSubmit")
                    : $t("ProductionPlans.actions.editSubmit")
                  : $t("ProductionPlans.actions.editSubmit")
              }}
            </v-btn>
          </v-sheet>
        </v-card-title>
        <v-card-text class="px-6 pb-4">
          <v-divider />
          <span v-if="isNew && !next">
            <v-row no-gutters class="mt-8">
              <span class="secondary--text">
                {{ $t("ProductionPlans.Fields.type") }}{{ $t("Global.colon") }}
              </span>
              <v-radio-group
                row
                hide-details
                v-model="production_plan.production_type"
                class="d-inline-block mt-n1"
              >
                <v-radio
                  v-for="type in $consts.pruductionPlan.type"
                  :label="type.text"
                  :key="type.value"
                  :value="type.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
          </span>
          <v-row v-else no-gutters class="mt-4 table-style">
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("ProductionPlans.Fields.type")
                  }}{{ $t("Global.colon") }}
                </span>
                {{ production_plan.production_type | productionPlansTypeText }}
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-expansion-panels v-model="panels" multiple accordion v-else>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("ProductionPlans.ObjectName")]) }}
              <v-chip
                v-if="production_plan.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="production_plan.status | productionPlansStatusColor"
                :text-color="
                  production_plan.status | productionPlansStatusTextColor
                "
                >{{ production_plan.status | productionPlansStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="(isNew && next) || preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="preview ? (preview = false) : (next = false)"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <v-btn
                  v-if="(isNew && next) || mode == 'edit'"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{
                    action
                      ? action == "confirm"
                        ? $t("ProductionPlans.actions.confirmSubmit")
                        : action == "approve"
                        ? $t("ProductionPlans.actions.approveSubmit")
                        : $t("ProductionPlans.actions.editSubmit")
                      : $t("ProductionPlans.actions.editSubmit")
                  }}
                </v-btn>
              </v-sheet>

              <ProductionPlanActions
                v-if="isView"
                :production_plan="production_plan"
                :showEdit="
                  production_plan.actions
                    ? production_plan.actions.account_edit
                    : false
                "
                @edit="mode = 'edit'"
                @confirm="
                  mode = 'edit';
                  action = 'confirm';
                "
                :showApprove="
                  production_plan.actions
                    ? production_plan.actions.approve
                    : false
                "
                @approve="
                  mode = 'edit';
                  action = 'approve';
                "
                detail-mode
              />
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4" v-if="mode == 'edit' || isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.production_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.type")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    production_plan.production_type | productionPlansTypeText
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.status")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.status | productionPlansStatusText }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.creater")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    production_plan.shop_user && production_plan.shop_user.name
                      ? production_plan.shop_user.name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.complete_date")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.complete_date | formatTime }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("ProductionPlans.actions.activities") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("ProductionPlans.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="production_plan_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="production_plan_relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>

                    <template v-slot:item.identify_name="{ item }">
                      <span v-if="!item.index" class="text-no-wrap">
                        {{ item.identify_name }}
                      </span>
                    </template>
                    <template v-slot:item.identify_code="{ item }">
                      <span class="text-no-wrap">
                        {{ item.identify_code }}
                      </span>
                      <br />
                      <span v-if="item.stock">
                        {{ item.stock.name }}
                      </span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status >= 0" class="text-no-wrap">
                        <v-chip
                          v-if="item.identify == 'production-stock-out'"
                          small
                          label
                          :color="item.status | stockOrderOUTStatusColor"
                          :text-color="
                            item.status | stockOrderOUTStatusTextColor
                          "
                          >{{ item.status | stockOrderOUTStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'production-stock-in'"
                          small
                          label
                          :color="item.status | stockOrderINStatusColor"
                          :text-color="
                            item.status | stockOrderINStatusTextColor
                          "
                          >{{ item.status | stockOrderINStatusText }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="
                          $permission.permissionAllow(item.controller, 'view')
                        "
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        :href="'/#/' + item.identify + '/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card v-if="showDetailTable" class="px-4 mt-4">
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-data-iterator
              :items="production_plan_details"
              :items-per-page.sync="production_plan_details.length"
              hide-default-footer
              class="py-5"
              no-data-text=""
            >
              <template v-slot:header>
                <v-toolbar flat class="transparent-background-color">
                  <v-toolbar-title class="ms-n2">
                    {{ $t("CRUD.details", [$t("ProductionPlans.ObjectName")]) }}
                  </v-toolbar-title>
                  <span class="caption secondary--text pt-2 ms-3">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        production_plan_details
                          ? [
                              1,
                              production_plan_details.length,
                              production_plan_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                </v-toolbar>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                  v-if="savable"
                >
                  <v-row align="center">
                    <keep-alive>
                      <v-autocomplete
                        color="primary"
                        v-model="productionMaterialSelected"
                        :items="production_materials"
                        :loading="productionMaterialLoading"
                        :search-input.sync="productionMaterialSearch"
                        item-value="id"
                        item-text="material_name"
                        item-disabled="disabled"
                        :label="$t('Material.ObjectName')"
                        return-object
                        style="margin-left: auto; margin-right: auto"
                        single-line
                        dense
                        hide-details
                        clearable
                      >
                      </v-autocomplete>
                    </keep-alive>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:default="{ items }">
                <v-card class="mt-2" v-for="item in items" :key="item.id">
                  <v-row class="ma-1">
                    <v-col>
                      <span class="secondary--text">
                        {{
                          production_plan.production_type == 2
                            ? $t("ProductionPlans.DetailFields.split_material")
                            : $t(
                                "ProductionPlans.DetailFields.combined_material"
                              )
                        }}
                        {{ $t("Global.colon") }}
                      </span>
                      <span
                        v-if="
                          item.standard_name && item.standard_name.length > 12
                        "
                        :title="item.standard_name"
                        style="cursor: pointer"
                      >
                        {{
                          $t("Material.materialNameWithCodeAndStandard", [
                            item.material_code,
                            item.material_name,
                            item.standard_name.slice(0, 12) + "......",
                          ])
                        }}
                      </span>
                      <span v-else>
                        {{
                          $t("Material.materialNameWithCodeAndStandard", [
                            item.material_code,
                            item.material_name,
                            item.standard_name,
                          ])
                        }}
                      </span>
                    </v-col>
                    <v-card-title class="me-3">
                      <v-tooltip left class="me-1" v-if="savable && item.new">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="danger--text pa-0"
                            @click="removeDetail(item)"
                            >fa-times
                          </v-icon>
                        </template>
                        <span>
                          {{ $t("ProductionPlans.actions.remove_detail") }}
                        </span>
                      </v-tooltip>
                    </v-card-title>
                  </v-row>
                  <v-divider />

                  <v-row class="ma-1">
                    <v-col
                      cols="12"
                      :md="production_plan.production_type == 1 ? '3' : '4'"
                    >
                      <span class="secondary--text">
                        {{
                          production_plan.production_type == 2
                            ? $t(
                                "ProductionPlans.DetailFields.split_material_num"
                              )
                            : $t(
                                "ProductionPlans.DetailFields.combined_material_num"
                              )
                        }}
                        {{ $t("Global.colon") }}
                      </span>
                      <div class="d-inline-block">
                        <NumberInput
                          v-if="savable && production_plan.production_type == 1"
                          v-model="item.production_num"
                          dense
                          @blur.native.capture="
                            updateProductionNum(item.material_id, item, true)
                          "
                        >
                          <template v-slot:append>
                            {{ item.unit }}
                          </template>
                        </NumberInput>
                        <ValidationProvider
                          v-else-if="
                            savable && production_plan.production_type == 2
                          "
                          v-slot="{ errors }"
                          :rules="{
                            max_value: {
                              max: item.current_count,
                            },
                          }"
                        >
                          <NumberInput
                            v-model="item.production_num"
                            :error-messages="errors"
                            dense
                            @blur.native.capture="
                              updateProductionNum(item.material_id, item, true)
                            "
                          >
                            <template v-slot:append>
                              {{ item.unit }}
                            </template>
                          </NumberInput>
                        </ValidationProvider>
                        <span v-else>
                          {{ item.production_num | formatTwoDot }}
                          {{ item.unit }}
                        </span>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="production_plan.production_type == 1"
                    >
                      <span class="secondary--text">
                        {{ $t("ProductionPlans.DetailFields.price") }}
                        {{ $t("Global.colon") }}
                      </span>
                      <div class="d-inline-block">
                        <v-text-field
                          v-if="savable"
                          v-model="item.in_price"
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          :prefix="$t('Global.money')"
                          @blur="
                            $numberFormatter.formatWithDotNoMoreThan(
                              item.in_price,
                              2
                            )
                          "
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") }}
                          {{ item.in_price | formatTwoDot }}
                        </span>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      :md="production_plan.production_type == 1 ? '3' : '4'"
                    >
                      <span class="secondary--text">
                        {{
                          $t("ProductionPlans.DetailFields.current_stock_count")
                        }}
                        {{ $t("Global.colon") }}
                      </span>
                      {{ item.current_count | formatTwoDot }}
                      {{ item.unit }}
                    </v-col>
                    <v-col
                      cols="12"
                      :md="production_plan.production_type == 1 ? '3' : '4'"
                    >
                      <v-select
                        v-if="savable && item.new"
                        v-model="item.formulaSelected"
                        :items="item.formulaDetails"
                        item-text="name"
                        item-value="uuid"
                        single-line
                        dense
                        hideDetails
                        class="mt-n1"
                        style="margin-left: auto; margin-right: auto"
                        return-object
                      />
                      <span v-else>
                        {{ item.formula_name }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-simple-table fixed-header class="ma-1 pb-2">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{
                              $t(
                                "ProductionPlans.DetailFields.material_category"
                              )
                            }}
                          </th>
                          <th class="text-center">
                            {{
                              $t("ProductionPlans.DetailFields.material_code")
                            }}
                          </th>
                          <th class="text-center">
                            {{
                              $t("ProductionPlans.DetailFields.material_name")
                            }}
                          </th>
                          <th class="text-center">
                            {{ $t("ProductionPlans.DetailFields.standard") }}
                          </th>
                          <th class="text-right">
                            {{ $t("ProductionPlans.DetailFields.changed_num") }}
                          </th>
                          <th
                            v-if="production_plan.production_type == 2"
                            class="text-right"
                          >
                            {{ $t("ProductionPlans.DetailFields.price") }}
                          </th>
                          <th class="text-right">
                            {{
                              $t("ProductionPlans.DetailFields.average_price")
                            }}
                          </th>
                          <th class="text-right">
                            {{ $t("ProductionPlans.DetailFields.stock_num") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="formula_detail in item.new
                            ? item.formulaSelected.formula_details
                            : item.formula_details"
                          :key="formula_detail.material_id"
                        >
                          <td class="text-left">
                            {{ formula_detail.category_name }}
                          </td>
                          <td class="text-center">
                            {{ formula_detail.material_code }}
                          </td>
                          <td class="text-center">
                            {{ formula_detail.material_name }}
                          </td>
                          <td class="text-center">
                            <span
                              v-if="
                                formula_detail.standard_name &&
                                formula_detail.standard_name.length > 12
                              "
                              :title="formula_detail.standard_name"
                              style="cursor: pointer"
                            >
                              {{
                                formula_detail.standard_name.slice(0, 12) +
                                "......"
                              }}
                            </span>
                            <span v-else>
                              {{ formula_detail.standard_name }}
                            </span>
                          </td>
                          <td class="text-right">
                            <ValidationProvider
                              v-if="
                                savable && production_plan.production_type == 1
                              "
                              v-slot="{ errors }"
                              :rules="{
                                max_value: {
                                  max: formula_detail.current_count,
                                },
                              }"
                            >
                              <NumberInput
                                v-model="formula_detail.production_num"
                                :error-messages="errors"
                                dense
                                @blur.native.capture="
                                  updateProductionNum(
                                    formula_detail.material_id,
                                    item,
                                    false
                                  )
                                "
                              >
                                <template v-slot:append>
                                  {{ formula_detail.unit }}
                                </template>
                              </NumberInput>
                            </ValidationProvider>
                            <NumberInput
                              v-else-if="
                                savable && production_plan.production_type == 2
                              "
                              v-model="formula_detail.production_num"
                              dense
                              @blur.native.capture="
                                updateProductionNum(
                                  formula_detail.material_id,
                                  item,
                                  false
                                )
                              "
                            >
                              <template v-slot:append>
                                {{ formula_detail.unit }}
                              </template>
                            </NumberInput>
                            <span v-else>
                              {{ formula_detail.production_num }}
                              {{ formula_detail.unit }}
                            </span>
                          </td>
                          <td
                            v-if="production_plan.production_type == 2"
                            class="text-right"
                          >
                            <v-text-field
                              v-if="savable"
                              v-model="formula_detail.in_price"
                              single-line
                              dense
                              hide-details
                              type="number"
                              min="0"
                              :prefix="$t('Global.money')"
                              @blur="
                                $numberFormatter.formatWithDotNoMoreThan(
                                  formula_detail.in_price,
                                  2
                                )
                              "
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") }}
                              {{ formula_detail.in_price }}
                            </span>
                          </td>
                          <td class="text-right">
                            {{ $t("Global.money") }}
                            {{ formula_detail.average_price | formatTwoDot }}
                          </td>
                          <td class="text-right">
                            {{ formula_detail.current_count | formatTwoDot }}
                            {{ formula_detail.unit }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </template>
            </v-data-iterator>
          </v-container>
        </ValidationObserver>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import ProductionPlans from "@/api/production_plans";
import ProductionPlanActions from "./plugins/Actions";
import NumberInput from "@/components/plugins/NumberInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import snackbar from "@/plugins/snackbar";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ProductionPlanActions,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return !this.preview && (this.mode == "new" || this.mode == "edit");
    },
    isNew() {
      return this.mode == "new";
    },
    showDetailTable() {
      return (
        (this.mode == "new" && this.next) ||
        this.mode == "edit" ||
        this.preview ||
        this.isView
      );
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.productionManagement"),
          disabled: false,
          replace: true,
          href: "/production-plans",
        },
        {
          text: i18n.t("Nav.productionPlans"),
          disabled: false,
          href: "/production-plans",
        },
        {
          text:
            this.mode == "confirm"
              ? i18n.t("Nav.orderConfirm")
              : this.mode == "approve"
              ? i18n.t("Nav.orderApprove")
              : this.isNew
              ? i18n.t("Nav.productionPlanNew")
              : i18n.t("Nav.productionPlanDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.production_plan && this.production_plan.stock_order_code
              ? this.production_plan.stock_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    headers() {
      var headers = [
        {
          text: i18n.t("ProductionPlans.DetailFields.material_name"),
          align: "center",
          value: "Description",
        },
        {
          text: i18n.t("ProductionPlans.DetailFields.changed_num"),
          align: "start",
          value: "changed_num",
        },
      ];

      if (this.production_plan.production_type == 2) {
        headers.push({
          text: i18n.t("ProductionPlans.DetailFields.price"),
          align: "center",
          value: "price",
        });
      }

      headers.push(
        {
          text: i18n.t("ProductionPlans.DetailFields.average_price"),
          align: "center",
          value: "average_price",
        },
        {
          text: i18n.t("ProductionPlans.DetailFields.stock_num"),
          align: "center",
          value: "stock_num",
        }
      );
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ProductionPlans.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ProductionPlans.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ProductionPlans.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("ProductionPlans.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    mode: "",
    action: "",
    production_plan: {},
    production_plan_details: [],
    production_plan_activities: [],
    next: false,
    production_materials: [],
    productionMaterialLoading: false,
    productionMaterialSearch: "",
    productionMaterialSelected: null,
    formulaSelected: null,
    preview: false,
    production_plan_relations: [],
  }),

  mounted() {
    if (this.$route.path.startsWith("/production-plans/new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      this.action = this.$route.params.action;
      if (this.mode) {
        if (this.action) {
          this.$router.replace(
            "/production-plans/" + this.$route.params.id + "/" + this.action
          );
        } else {
          this.$router.replace("/production-plans/" + this.$route.params.id);
        }
      }
    }
  },

  methods: {
    //获取商品列表
    getProductionMaterialsFromAPI() {
      ProductionPlans.getProductionMaterials({
        production_type: this.production_plan.production_type,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            var materials = response.data.materials;
            this.production_materials = Object.values(materials).map((item) => {
              const disabled =
                this.production_plan_details &&
                this.production_plan_details.find(
                  (detail) => detail.material_id == item.material_id
                )
                  ? true
                  : item.disabled
                  ? true
                  : false;
              return Object.assign({}, item, { disabled });
            });
          }
        }.bind(this)
      );
    },
    // 获取单据详情
    getProductionPlanFromAPI() {
      ProductionPlans.fetchOne(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.production_plan = response.data.production_plan;
            this.production_plan_details =
              response.data.production_plan.production_plan_history_details;
            this.production_plan_activities = response.data.order_activities;
            this.production_plan_relations = [];
            if (response.data.production_plan.stock_out) {
              this.production_plan_relations.push(
                Object.assign(
                  {
                    controller: "StockOutOrders",
                    identify: "production-stock-out",
                    identify_name: i18n.t("stockOutOrders.ObjectName"),
                    identify_code:
                      response.data.production_plan.stock_out.stock_order_code,
                    creater_name:
                      this.production_plan.shop_user &&
                      this.production_plan.shop_user.name
                        ? this.production_plan.shop_user.name
                        : "",
                  },
                  response.data.production_plan.stock_out
                )
              );
            }
            if (
              response.data.production_plan.stock_in &&
              this.production_plan.status >= 4
            ) {
              this.production_plan_relations.push(
                Object.assign(
                  {
                    controller: "StockInOrders",
                    identify: "production-stock-in",
                    identify_name: i18n.t("stockInOrders.ObjectName"),
                    identify_code:
                      response.data.production_plan.stock_in.stock_order_code,
                    creater_name:
                      this.production_plan.shop_user &&
                      this.production_plan.shop_user.name
                        ? this.production_plan.shop_user.name
                        : "",
                  },
                  response.data.production_plan.stock_in
                )
              );
            }
          }
        }.bind(this)
      );
    },
    // 主数据和子数据的数量联动
    updateProductionNum(material_id, production, master) {
      if (master) {
        if (this.isNew || production.new) {
          //取主数据的拆零或组装数量
          if (production.production_num > 0) {
            if (production.formulaSelected) {
              production.formulaSelected.formula_details.forEach(
                (formula_detail) => {
                  formula_detail.production_num =
                    formula_detail.ratio * production.production_num;
                }
              );
            } else {
              production.formula_details.forEach((formula_detail) => {
                formula_detail.production_num =
                  formula_detail.ratio * production.production_num;
              });
            }
          }
        } else if (this.mode == "edit" && !production.new) {
          if (this.production_plan.production_type == 1) {
            if (production.production_num > 0) {
              production.formula_details.forEach((formula_detail) => {
                formula_detail.production_num =
                  formula_detail.ratio * production.production_num;
              });
            }
          } else if (this.production_plan.production_type == 2) {
            if (production.production_num > 0) {
              production.formula_details.forEach((formula_detail) => {
                formula_detail.production_num =
                  formula_detail.ratio * production.production_num;
              });
            }
          }
        }
      } else {
        if (this.isNew) {
          //获取编辑的子数据计算主数据相应的数量
          let editDetail = production.formulaSelected.formula_details.find(
            (formula_detail) => formula_detail.material_id == material_id
          );
          production.production_num = this.$numberFormatter.formatTwoDot(
            editDetail.production_num / editDetail.ratio
          );
          //根据计算后的主数据数量计算子数据的数量
          production.formulaSelected.formula_details.forEach(
            (formula_detail) => {
              formula_detail.production_num =
                this.$numberFormatter.formatTwoDot(
                  formula_detail.ratio * production.production_num
                );
            }
          );
        } else if (this.mode == "edit") {
          if (this.production_plan.production_type == 1) {
            //获取编辑的子数据计算主数据相应的数量
            let editDetail = production.formula_details.find(
              (formula_detail) => formula_detail.material_id == material_id
            );
            production.production_num = this.$numberFormatter.formatTwoDot(
              editDetail.production_num / editDetail.ratio
            );
            //根据计算后的主数据数量计算子数据的数量
            production.formula_details.forEach((formula_detail) => {
              formula_detail.production_num =
                this.$numberFormatter.formatTwoDot(
                  formula_detail.ratio * production.production_num
                );
            });
          } else if (this.production_plan.production_type == 2) {
            //获取编辑的子数据计算主数据相应的数量
            let editDetail = production.formula_details.find(
              (formula_detail) => formula_detail.material_id == material_id
            );
            production.production_num = this.$numberFormatter.formatTwoDot(
              editDetail.production_num / editDetail.ratio
            );
            //根据计算后的主数据数量计算子数据的数量
            production.formula_details.forEach((formula_detail) => {
              formula_detail.production_num =
                this.$numberFormatter.formatTwoDot(
                  formula_detail.ratio * production.production_num
                );
            });
          }
        }
      }
    },
    // 移除某个商品
    removeDetail(productionMaterialDetail) {
      this.production_plan_details.splice(
        this.production_plan_details.findIndex(
          (detail) => detail.id == productionMaterialDetail.id
        ),
        1
      );
      this.production_materials.find((material) => {
        if (material.id == productionMaterialDetail.id) {
          material.disabled = false;
        }
      });
    },
    //处理提交数据
    submitData() {
      let production_plan_order = {};
      if (this.isNew) {
        production_plan_order = {
          production_type: this.production_plan.production_type,
          policy_type: 1,
          production_plan_history_details: [],
        };
      } else if (this.mode == "edit") {
        production_plan_order = {
          id: this.production_plan.id,
          production_plan_history_details: [],
        };
        if (this.action) {
          production_plan_order.status =
            this.action == "confirm" ? 2 : this.action == "approve" ? 3 : 0;
        }
      }

      this.production_plan_details.forEach((detail) => {
        let history_detail = {};
        if (this.mode == "edit" && !detail.new) {
          if (!this.preview) {
            if (!detail.new) {
              history_detail = {
                id: detail.id,
                production_num: detail.production_num,
              };
            } else {
              history_detail = {
                material_code: detail.material_code,
                production_num: detail.production_num,
                formula_code: this.preview
                  ? detail.formula_code
                  : detail.new
                  ? detail.formulaSelected.uuid
                  : detail.formula_code,
              };
            }
          } else {
            if (!detail.id) {
              history_detail = {
                material_code: detail.material_code,
                production_num: detail.production_num,
                formula_code: this.preview
                  ? detail.formula_code
                  : detail.new
                  ? detail.formulaSelected.uuid
                  : detail.formula_code,
              };
            } else {
              history_detail = {
                id: detail.id,
                production_num: detail.production_num,
              };
            }
          }
        } else {
          history_detail = {
            material_code: detail.material_code,
            production_num: detail.production_num,
            formula_code: this.preview
              ? detail.formula_code
              : detail.new
              ? detail.formulaSelected.uuid
              : detail.formula_code,
          };
        }

        let formula_materials = [];

        if (this.production_plan.production_type == 2) {
          if (this.preview) {
            detail.formula_details.forEach((material) => {
              formula_materials.push({
                material_id: material.material_id,
                in_price: material.in_price,
              });
            });
          } else {
            if (detail.new) {
              detail.formulaSelected.formula_details.forEach((material) => {
                formula_materials.push({
                  material_id: material.material_id,
                  in_price: material.in_price,
                });
              });
            } else {
              detail.formula_details.forEach((material) => {
                formula_materials.push({
                  material_id: material.material_id,
                  in_price: material.in_price,
                });
              });
            }
          }

          history_detail.formula_details = formula_materials;
        }
        if (this.production_plan.production_type == 1) {
          history_detail.in_price = detail.in_price;
        }

        production_plan_order.production_plan_history_details.push(
          history_detail
        );
      });

      return production_plan_order;
    },
    //提交预览
    doPreview() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (this.production_plan_details.length) {
              let submitData = this.submitData();
              if (this.isNew) {
                ProductionPlans.addPreview(submitData).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.preview = true;
                      this.production_plan = response.data.production_plan;
                      this.production_plan_details =
                        response.data.production_plan.production_plan_history_details;
                    }
                  }.bind(this)
                );
              } else if (this.mode == "edit") {
                ProductionPlans.editPreview(submitData).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.preview = true;
                      this.production_plan = response.data.production_plan;
                      this.production_plan_details =
                        response.data.production_plan.production_plan_history_details;
                    }
                  }.bind(this)
                );
              }
            } else {
              // this.$snackbar.error(i18n.t("ProductionPlans.submitNullErrMassage"))
              snackbar.error(i18n.t("ProductionPlans.submitNullErrMassage"));
            }
          }
        }.bind(this)
      );
    },
    //单据提交
    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      let submitData = this.submitData();
      if (this.isNew) {
        ProductionPlans.add(submitData)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$router.push("/production-plans");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      } else if (this.mode == "edit") {
        ProductionPlans.edit(submitData)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$router.push("/production-plans");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isNew) {
          this.production_plan = {
            production_type: 2,
          };
        } else if (this.$route.params.id) {
          this.getProductionPlanFromAPI();
        }
      },
    },
    production_plan: {
      deep: true,
      handler() {
        if (this.production_plan) {
          this.getProductionMaterialsFromAPI();
        }
      },
    },
    next: {
      handler() {
        if (this.next) {
          this.getProductionMaterialsFromAPI();
        } else {
          this.production_plan_details = [];
          this.production_materials = [];
          this.productionMaterialSelected = [];
        }
      },
    },
    productionMaterialSelected: {
      deep: true,
      handler() {
        if (
          this.productionMaterialSelected &&
          this.productionMaterialSelected.id
        ) {
          ProductionPlans.getProductionMaterialDetails({
            production_type: this.production_plan.production_type,
            material_id: this.productionMaterialSelected.material_id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                var production_material = response.data.production_material;
                var formulaDetails = Object.values(production_material.formula);
                formulaDetails.forEach((formula) => {
                  formula.formula_details.forEach((detail) => {
                    detail.production_num = "";
                    detail.in_price = 0;
                  });
                });

                this.production_plan_details.push(
                  Object.assign(production_material, {
                    new: this.production_plan_details.length + 1,
                    production_num: "",
                    formulaDetails: formulaDetails,
                    formulaSelected:
                      production_material.formula[
                        production_material.formula_default_key
                      ],
                  })
                );
              }
            }.bind(this)
          );

          //设置商品select禁选项
          this.production_materials = this.production_materials.map((item) => {
            const disabled =
              this.productionMaterialSelected &&
              this.productionMaterialSelected.id == item.id
                ? true
                : item.disabled
                ? true
                : false;
            return Object.assign({}, item, { disabled });
          });

          this.productionMaterialSelected = {};
        }
      },
    },
    production_plan_details: {
      deep: true,
      handler() {},
    },
  },
};
</script>